import { Navigate, Outlet } from "react-router-dom";
import { useAuthContext } from "../context/authContext";
import { routerPaths } from "../constants/Paths";

export default function PrivateRoute() {
  const { isLoggedIn } = useAuthContext();
  return isLoggedIn ? <Outlet /> : <Navigate to={`/${routerPaths.LOGIN}`} />;
}
